import React, { Component } from 'react';
import Cover from './Cover';
import About from './About';
import Contact from './Contact';
import Portfolio from './Portfolio';
import '../Style/main.css';

class App extends Component {

	componentDidMount() {
		const body = document.querySelector("body");

		body.addEventListener("contextmenu",  e => {
			e.preventDefault();
		})
	}

	render() {
		return (
			<div id="App" className="column-container">
				<header>
					<Cover />
				</header>

				<main className="column-container">
					<Portfolio noPics={30}/>
					<About />
					{/*<Contact />*/}
				</main>
				<footer id="Contact" className="center column-container">
					<div className="gutter">
					
						<h3>Contact Me</h3>

						<div className="grid-1">
							<i className="envelope icon large"></i> <span> jademaryconradie4@gmail.com </span>
							<i className="instagram icon large"></i> <span> a_.thousand._words </span>
							<i className="whatsapp icon large"></i> <span> 083 666 6198 </span>
						</div>

					</div>
					<div className="foot center">
						Jade Conradie &copy; 2021
					</div>
				</footer>
			</div>
		)
	}
}

export default App;